import styled from "styled-components";

import { TicketsStyledProps as Props } from "./Tickets.types";
import CONSTANTS from "config/constants";

const { desktop, tablet, mobile } = CONSTANTS.BREAKPOINTS;

const TicketsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;

  .Tickets {
    &__header {
      grid-column: fullBleed;
    }

    &__main {
      flex: 1;
      grid-column: fullBleed;
      display: flex;
      justify-content: space-between;

      @media (max-width: ${tablet - 1}px) {
        flex-direction: column;
      }
    }

    &__container {
      background-color: var(--palette-dark-blue-s13-l11);
      margin-inline: auto;
      padding: 3.2rem;
      border-radius: 2.4rem;
      margin-top: 5.6rem;
      flex: 0.8;
      max-height: calc(var(--sizes-page-maxHeight) - 20rem);
      overflow-x: hidden;
      overflow-y: auto;

      @media (max-width: ${desktop - 1}px) {
        flex: 1;
        margin-top: 0;
        max-height: calc(var(--sizes-page-maxHeight) - 12rem);
      }

      @media (max-width: ${tablet - 1}px) {
        max-height: calc(var(--sizes-page-maxHeight) - 30rem);
        margin-inline: unset;
        padding: 0 1.6rem;
        margin-top: 0;
        border-radius: unset;
      }

      ::-webkit-scrollbar {
        width: 0;
      }
    }

    &__ticket {
      margin-bottom: 1.6rem;

      @media (max-width: ${tablet - 1}px) {
        max-width: 24rem;
        margin-right: 1.6rem;

        .Ticket {
          &__mobile {
            display: none;
          }
        }
      }
    }

    &__no-desktop {
      display: none;

      @media (max-width: ${tablet - 1}px) {
        display: flex;
        padding: 1.6rem 0;
      }
    }

    &__desktop {
      display: flex;
      justify-content: space-between;
      border-bottom: 0.2rem dashed var(--palette-gray-s0-l40);

      @media (max-width: ${tablet - 1}px) {
        border-bottom: unset;
      }
    }

    &__info {
      display: flex;
      align-items: center;

      @media (max-width: ${tablet - 1}px) {
        display: none;
      }

      &__mobile {
        display: none;

        @media (max-width: ${mobile}px) {
          display: flex;
          align-items: center;
          margin-right: 1.6rem;
        }
      }
    }

    &__laurel {
      transform: rotateY(0deg);
      width: 1.6rem;
      height: 4.8rem;

      &__right {
        transform: rotateY(180deg);
      }

      @media (max-width: ${tablet - 1}px) {
        width: 2.4rem;
        height: 7.2rem;
      }
    }

    &__points {
      justify-content: center;
      padding: 0 0.4rem;

      &__text {
        color: var(--palette-light-blue-s10-l60);
        font-size: 1.4rem;
        font-weight: 600;
        line-height: 1.6rem;
        text-align: center;
      }
    }

    &__selected {
      padding-bottom: 2.4rem;
      flex: 1;

      @media (max-width: ${tablet - 1}px) {
        display: none;
      }
    }

    &__mobile {
      display: none;

      @media (max-width: ${tablet - 1}px) {
        display: flex;
        flex: 0.4;
        padding-top: 2.4rem;
      }
    }

    &__movies {
      grid-column: fullBleed;
      width: 40.8rem;
      padding: 2.4rem 1.6rem;
      border-left: 0.2rem solid var(--palette-mid-blue-s13-l18);
      background-color: var(--palette-dark-blue-s13-l11);
      display: flex;
      flex-direction: column;

      @media (max-width: ${tablet}px) {
        width: 32rem;
      }

      &__list {
        @media (min-width: ${tablet}px) {
          display: flex;
          flex-direction: column;
        }

        @media (max-width: ${tablet - 1}px) {
          display: none;
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &__title {
        color: var(--palette-gray-s0-l70);
        font-size: 2rem;
        padding-top: 3.2rem;
        padding-bottom: 1.6rem;

        @media (max-width: ${tablet - 1}px) {
          display: none;
        }
      }

      @media (max-width: ${tablet - 1}px) {
        border-left: none;
        padding: 0 1.6rem;
        width: auto;
      }
    }

    &__sticky-button {
      position: fixed;
      width: 100%;
      bottom: 0;
      right: 0;
      z-index: 1;
      padding: 1.6rem;
      background-color: var(--palette-dark-blue-s13-l11);
    }

    &__button {
      margin-top: auto;
      cursor: pointer;

      &-desktop {
        @media (max-width: ${tablet - 1}px) {
          display: none;
        }
      }

      &-mobile {
        margin: 0.8rem 0;

        @media (min-width: ${tablet - 1}px) {
          display: none;
        }
      }
    }
  }
`;

export default TicketsStyled;
